import React from 'react';
import { BookOpen, Shield, Award, MessageCircle, Users, CheckCircle, Lightbulb } from 'lucide-react';
import { benefits } from '../data/mock';

const iconMap = {
  BookOpen: BookOpen,
  Shield: Shield,
  Award: Award,
  MessageCircle: MessageCircle,
  Users: Users,
  CheckCircle: CheckCircle,
  Lightbulb: Lightbulb
};

const Benefits = () => {
  return (
    <section id="benefits" className="py-24 bg-gradient-to-b from-white via-orange-50/30 to-white relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-20 right-0 w-96 h-96 bg-gradient-to-br from-orange-200/30 to-amber-200/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-0 w-96 h-96 bg-gradient-to-br from-amber-200/30 to-yellow-200/30 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Dlaczego{' '}
            <span className="bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent">
              Zosia?
            </span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Inwestycja, która przynosi realne korzyści Twojej placówce i wspiera rozwój dzieci
          </p>
        </div>

        {/* Benefits grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];

            return (
              <div
                key={benefit.id}
                className="group relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 hover:shadow-xl transition-all duration-300 border border-slate-100 hover:border-orange-200"
                style={{
                  animationDelay: `${index * 100}ms`
                }}
              >
                {/* Icon */}
                <div className="mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-amber-500 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-orange-600 transition-colors">
                  {benefit.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {benefit.description}
                </p>

                {/* Hover effect decoration */}
                <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-orange-500/5 to-amber-500/5 rounded-bl-full transform scale-0 group-hover:scale-100 transition-transform duration-300"></div>
              </div>
            );
          })}
        </div>

        {/* Trust section */}
        <div className="mt-20 bg-gradient-to-r from-orange-500 to-amber-500 rounded-3xl p-8 sm:p-12 text-white text-center shadow-2xl">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-3xl font-bold mb-4">
              Dołącz do setek zadowolonych placówek w całej Polsce
            </h3>
            <p className="text-lg text-orange-50 mb-8">
              Zosia jest już wykorzystywana przez przedszkola i szkoły jako narzędzie wspierające
              edukację w duchu metodologii STEAM
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-8 sm:gap-12">
              <div>
                <div className="text-4xl font-bold mb-1">500+</div>
                <div className="text-orange-100">Placówek</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-1">15 000+</div>
                <div className="text-orange-100">Dzieci</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-1">4.9/5</div>
                <div className="text-orange-100">Ocena</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
